import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { c, h } from '@debbie/cortex/dist/index.js';
import * as casesAPI from '@debbie/cortex/dist/api/cases.js';
import { useBillingAppendixSetups } from '@debbie/cortex/dist/billing-appendix-setups/index.js';
import { useBillingModels } from '@debbie/cortex/dist/billing-models/index.js';
import keys from '@debbie/common/dist/cache/keys.js';
import { selectCaseLoadingStateById } from '@debbie/cortex/dist/cases/selectors.js';
import q from '@debbie/cortex/dist/query.js';
import { Badge, DateInput, Modal, PlaceholderLoader, Well, } from '../../index.js';
import THEME from '../../../theme.js';
import OngoingWork from '../../economy/OngoingWork.js';
import GenericSelector from '../../GenericSelector.js';
import { Col, Row } from '../../Grid/index.js';
import BillingAppendixSetupSearch from '../../search/BillingAppendixSetupSearch.js';
import BillingModelSearch from '../../search/BillingModelSearch.js';
import BillingAppendixSetup from '../BillingAppendixSetup.js';
import Billings from '../Billings.js';
import BillingModel from '../BillingModel/BillingModel.js';
import { casesEntity } from '@debbie/cortex/dist/cases/index.js';
import { billingVouchersKey } from '@debbie/cortex/dist/billing-vouchers/index.js';
const CaseBillingModal = (props) => {
    const lang = useSelector((s) => s.lang);
    const singleCaseLoadable = useSelector((s) => selectCaseLoadingStateById(s, props.caseId));
    const singleCase = h.hasData(singleCaseLoadable)
        ? singleCaseLoadable.data
        : null;
    const billingModelsLoadable = useBillingModels();
    const billingModels = h.hasData(billingModelsLoadable)
        ? billingModelsLoadable.data
        : null;
    const [billingModelId, setBillingModelId] = useState(null);
    const [billingStartDate, setBillingStartDate] = useState(null);
    const [billingAppendixSetupId, setBillingAppendixSetupId] = useState(null);
    useEffect(() => {
        if (singleCase) {
            setBillingModelId(singleCase.billingModelId);
            setBillingStartDate(singleCase.billingStartDate
                ? moment(singleCase.billingStartDate)
                : null);
            setBillingAppendixSetupId(singleCase.billingAppendixSetupId);
        }
    }, [singleCase]);
    return (React.createElement(Modal, { onToggle: props.onToggle, maxWidth: "1200px", header: lang.clientBilling.clientBilling },
        billingModels && singleCase ? (React.createElement(Well, null,
            singleCase.tags.length > 0 && (React.createElement(Row, { style: { marginBottom: '15px' } }, singleCase.tags.map((tag) => (React.createElement(Badge, { key: tag.tag, theme: THEME.COLOR_ACCENT, style: { marginRight: '5px' } },
                lang.caseTags[tag.tag] || tag.tag,
                tag.from || tag.to
                    ? ` (${tag.from
                        ? moment(tag.from).format(THEME.DATE_FORMAT_SHORT)
                        : '∞'} - ${tag.to
                        ? moment(tag.to).format(THEME.DATE_FORMAT_SHORT)
                        : '∞'})`
                    : ''))))),
            React.createElement(Row, null,
                React.createElement(Col, { width: "4" },
                    React.createElement(BillingModelSelector, { singleCase: singleCase })),
                React.createElement(Col, { width: "4" },
                    React.createElement(DateInput, { placeholder: "Start afregning af indbetalinger fra", allowNull: true, value: billingStartDate, onChange: async (date) => {
                            try {
                                setBillingStartDate(date);
                                await casesAPI.patch(props.caseId, {
                                    billingStartDate: date
                                        ? date.startOf('day').format()
                                        : null,
                                });
                                await c.cases.getById(props.caseId);
                                q.invalidate([
                                    ...keys.write.modify(casesEntity, props.caseId),
                                ]);
                            }
                            catch (error) {
                                console.error(error);
                                alert('Error');
                            }
                        } })),
                React.createElement(Col, { width: "4" },
                    React.createElement(BillingAppendixSetupSelector, { singleCase: singleCase }))))) : (React.createElement(PlaceholderLoader, null)),
        React.createElement("h3", null, lang.billing.ongoingWork),
        React.createElement(OngoingWork, { caseId: props.caseId, highlightCaseId: props.caseId }),
        React.createElement("h3", null, lang.billing.bills),
        React.createElement(Billings, { caseId: props.caseId, highlightCaseId: props.caseId })));
};
export default CaseBillingModal;
const BillingModelSelector = (props) => {
    return (React.createElement(GenericSelector, { id: props.singleCase.billingModelId, mutatationFn: async (id) => {
            await casesAPI.patch(props.singleCase.caseId, {
                billingModelId: id,
            });
            await c.cases.getById(props.singleCase.caseId);
            q.invalidate([
                ...keys.write.modify(casesEntity, props.singleCase.caseId),
                billingVouchersKey(props.singleCase.caseId),
            ]);
        }, searchElement: BillingModelSearch, preview: () => {
            const lang = useSelector((s) => s.lang);
            const [show, setShow] = useState(false);
            const billingModelsLoader = useBillingModels();
            const billingModel = (h.hasData(billingModelsLoader) ? billingModelsLoader.data : []).find((bm) => bm.billingModelId === props.singleCase.billingModelId);
            return (React.createElement(React.Fragment, null,
                show && billingModel ? (React.createElement(Modal, { maxWidth: "1200px", header: lang.economy.newBillingModel, onToggle: () => setShow(false) },
                    React.createElement(BillingModel, { billingModel: billingModel }))) : null,
                React.createElement(PreviewText, { onClick: () => {
                        setShow(true);
                    } }, lang.billingModels.previewBillingModel)));
        } }));
};
const BillingAppendixSetupSelector = (props) => {
    return (React.createElement(GenericSelector, { id: props.singleCase.billingAppendixSetupId, mutatationFn: async (id) => {
            await casesAPI.patch(props.singleCase.caseId, {
                billingAppendixSetupId: id,
            });
            await c.cases.getById(props.singleCase.caseId);
            q.invalidate([
                ...keys.write.modify(casesEntity, props.singleCase.caseId),
                billingVouchersKey(props.singleCase.caseId),
            ]);
        }, searchElement: BillingAppendixSetupSearch, preview: () => {
            const lang = useSelector((s) => s.lang);
            const [show, setShow] = useState(false);
            const billingAppendixSetupsLoader = useBillingAppendixSetups();
            const billingAppendixSetup = (h.hasData(billingAppendixSetupsLoader)
                ? billingAppendixSetupsLoader.data
                : []).find((bm) => bm.billingAppendixSetupId ===
                props.singleCase.billingAppendixSetupId);
            return (React.createElement(React.Fragment, null,
                show && billingAppendixSetup ? (React.createElement(Modal, { maxWidth: "1200px", header: lang.economy.billingAppendixSetup, onToggle: () => setShow(false) },
                    React.createElement(BillingAppendixSetup, { billingAppendixSetup: billingAppendixSetup }))) : null,
                React.createElement(PreviewText, { onClick: () => {
                        setShow(true);
                    } }, lang.billingAppendixSetups.previewBillingAppendixSetup)));
        } }));
};
const PreviewText = styled.p `
  margin: 0;
  font-size: 0.8em;
  font-weight: bold;
  color: ${THEME.COLOR_ACCENT};
  cursor: pointer;
`;
//# sourceMappingURL=CaseBillingModal.js.map